<template>
  <li
    v-editable="blok"
    :class="[spaceBetweenItems, computedFontStyle, computedTextColor]"
  >
    <BaseRichText :rich-text-template="blok.text" />
  </li>
</template>

<script lang="ts" setup>
import type {
  SbListItemRichtextStoryblok,
  SbPluginInfermedicaFontPicker,
} from '@/types'
interface Props {
  blok: SbListItemRichtextStoryblok
  space: string
  font: SbPluginInfermedicaFontPicker | void
}
const props = withDefaults(defineProps<Props>(), {
  space: '4',
})

const spaceBetweenItems = computed(() => {
  return `mb-${props.space}` || 'mb-4'
})

const computedFontStyle = computed(() => {
  return props.font?.font.value ?? 'paragraph--m'
})

const computedTextColor = computed(() => {
  return `text-${props.font?.color_name}` ?? ''
})
</script>
